import React, { useState } from 'react';
import { apiUrl } from '../utils/api';

export default function Login({ onLogin }) {
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      const res = await fetch(apiUrl('/auth/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, password }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Usuario o contraseña incorrectos');
      }
      const data = await res.json();
      localStorage.setItem('iunic_token', data.token);
      localStorage.setItem('iunic_usuario', data.usuario);
      onLogin(data.usuario);
    } catch (e) {
      setError(e.message);
    } finally {
      setCargando(false);
    }
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: '#f3f4f6'
    }}>
      <form onSubmit={handleSubmit} style={{
        background: 'white', padding: '2rem', borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.1)', width: '320px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src="/assets/logo.png" alt="IUNIC Motors" style={{ maxHeight: '60px' }} />
        </div>
        <h2 style={{ marginBottom: '1rem', fontSize: '1.1rem', textAlign: 'center' }}>Iniciar sesión</h2>
        <input
          type="text"
          placeholder="Usuario"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          autoFocus
          style={{ width: '100%', padding: '0.6rem', marginBottom: '0.75rem', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        <input
          type="password"
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ width: '100%', padding: '0.6rem', marginBottom: '0.75rem', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        {error && <div style={{ color: '#c0392b', marginBottom: '0.75rem', fontSize: '0.9rem' }}>{error}</div>}
        <button type="submit" disabled={cargando} style={{
          width: '100%', padding: '0.6rem', borderRadius: '6px', border: 'none',
          background: '#1a73e8', color: 'white', fontWeight: 600, cursor: 'pointer'
        }}>
          {cargando ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
